import { gql } from '@apollo/client';

export const AnswerTheQuestionOfDictationMutation = gql`
    mutation AnswerTheQuestionOfDictation($questionId: ID!, $answerIds: [ID!]!) {
        answerTheQuestionOfDictation(questionId: $questionId, answerIds: $answerIds)
    }
`;
